import React from 'react';
import Action, { IActionParentProps } from '../Action';
import useStreamingSession from '../../hooks/useSession';
import MarkdownContent from '../MarkdownContent';

function CriticContent(message: string) {
  return (
    <div className='analysis'>
      <MarkdownContent content={message} />
    </div>
  );
}

export function Critic({ streamingSession, oggService }: IActionParentProps) {
  console.debug('loading critic');
  const [streamingContent] = useStreamingSession(streamingSession);

  return (
    <Action
      presentation={{
        name: 'The Critic',
        description: <p>Let me critically evaluate your content for quality and coherence.</p>,
        imageName: 'TheCritic.png',
        onStart: () => oggService.analyzeStream(streamingSession),
      }}
      streamOutput={{
        loadingTitle: 'Ogg is analyzing the work item...',
        loadingSubtitle: 'Fetching the analysis table from the server',
        render: CriticContent,
        streamingContent: streamingContent,
        streamingSession: streamingSession,
      }}
    ></Action>
  );
}
